import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './base.query';
import { IStatistics, UpdatePasswordRequest, UpdateProfileRequest, UpdateProfileResponse } from '../../types/user.type';

export enum AuthTags {
    UPDATE_PROFILE = 'update_profile',
    GET_ANALYTICS = 'get_analytics'
}

export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(AuthTags),
  endpoints: (builder) => ({
    updateProfile: builder.mutation<{data: UpdateProfileResponse}, UpdateProfileRequest>({
      query: (UserData) => ({
        url: 'Users/UpdateProfile',
        method: 'POST',
        body: UserData,
      }),
    }),
    updateProfilePicture: builder.mutation<{data: UpdateProfileResponse}, FormData>({
        query: (data)=> ({
            url: 'Users/UpdateProfilePicture',
            method: 'POST',
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            body: data,
        }), 
    }),
    updatePassword: builder.mutation<{data: UpdateProfileResponse}, UpdatePasswordRequest>({
        query: (data) => ({
            url: 'Users/ChangePassword',
            method: 'POST',
            body: data,  
        })
    }),
    getAnalytics: builder.query<IStatistics, void> ({
      query: (data) => ({
        url: 'Users/GetAnalytics',
        method: 'GET',
    }),
    providesTags: [AuthTags.GET_ANALYTICS],
    })
  }),
});

export const { 
  useUpdateProfileMutation, 
  useUpdateProfilePictureMutation, 
  useUpdatePasswordMutation,
  useGetAnalyticsQuery
} = profileApi;

export default profileApi;
